<template>
  <div id="qanda-page" ref="whole_page">
    <ul class="fixed-max-width-650" style="flex-wrap: wrap;">
      <li class="mb-5">
        <vx-card ref="chat_card" class="q-and-a-item__black-gradient vs-con-loading__container">
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="vx-row">
                <div class="vx-col w-2/5 self-center">
                  <svg xmlns="http://www.w3.org/2000/svg" style="color: white" width="100" height="100" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                </div>
                <div class="vx-col w-3/5 self-center">
                  <p class="uppercase" :class="{'gradient-text_header__50': windowWidth < 570 || isMobile(), 'gradient-text_header': windowWidth >= 570 && !isMobile()}">Q&A</p>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mt-5">
            <div class="vx-col w-full">
              <vx-card id="q-and-a-search-input_container" class="card__no-padding" style="border-radius: 30px !important;background-color: rgb(102, 102, 102);">
                <vx-input-group>
                  <vs-input class="w-full q-and-a-search_input" @keyup.enter="executeSearch" onClick="this.select();" placeholder="Search..." v-model="query" />

                  <template slot="append" class="append-slot-border">
                    <div @click="executeSearch" class="append-text school-primary_gradient input-search_button" style="border-radius: 30px !important;">
                      <span><feather-icon class="pt-1" icon="SearchIcon" svg-classes="stroke-current"></feather-icon></span>
                    </div>
                  </template>
                </vx-input-group>
              </vx-card>
            </div>
          </div>
        </vx-card>
      </li>      
    </ul>
    <ul v-show="faqs.length > 0" class="fixed-max-width-650 text-left q-and-a_list" style="flex-wrap: wrap;">
      <li class="mb-4">
        <vs-collapse id="collapse" accordion class="mb-3">
          <vs-collapse-item :id="`collapse-item-${index}`" icon-pack="feather" icon-arrow="icon-arrow-down-circle"  v-for="(_faq, index) in faqs" :key="index">
            <div slot="header">
              <h3><strong>{{ _faq.heading }}</strong></h3>
              <p class="mt-2" style="padding-right: 39px;">{{ _faq.question }}</p>
            </div>
            <div class="pl-3 mb-1">
              <p class="text-white" style="font-size: 12pt;"><strong>{{ _faq.answer }}</strong></p>
            </div>

            <div class="vx-row mt-3">
              <div class="vx-col w-full">
                <div v-if="showHelpfulBtns" class="flex helpful_btns__container justify-center">
                  <vs-button id="helpful-btn" class="vs-con-loading__container helpful_btns" ref="submit_btn" icon-pack="feather" icon="icon-check-circle" @click="faqFeedback(_faq.id, true)">Helpful</vs-button>
                  <vs-button id="unhelpful-btn" class="vs-con-loading__container helpful_btns" ref="submit_btn" icon-pack="feather" icon="icon-x-circle" icon-after @click="faqFeedback(_faq.id, false)">Not Helpful</vs-button>
                </div>
                <div v-else class="flex helpful_btns__container justify-center">
                  <vs-button id="done-btn" class="vs-con-loading__container helpful_btns" icon-pack="feather" icon="icon-check"/>
                </div>
              </div>
            </div>

            <div v-if="_faq.mediaContent.length > 0" class="vx-row">
              <div class="vx-col w-full">
                <vs-divider>Multimedia</vs-divider>
                <ul class="text-left q-and-a_list" style="flex-wrap: wrap;">
                  <li v-for="(_item, index) in _faq.mediaContent" :key="index" class="mb-4">
                    <vx-card class="glow-effect_dark limit-height_content-height card__no-padding bg-color">
                      <vx-input-group>
                        <template slot="prepend">
                          <div class="prepend-text glow-effect_dark limit-height_content-height input-group_prepend-slot-bg" style="width: 70px;border-radius: 5px 0 0 5px !important;">
                            <span><feather-icon class="pt-1 ml-3" :icon="getIcon(_item)" svg-classes="stroke-current"></feather-icon></span>
                          </div>
                        </template>

                        <vs-button size="large"
                          class="w-full glow-effect_primary limit-height_content-height button-text__left-align school-primary_gradient"
                          style="border-radius:0 7px 7px 0;"
                          @click.stop="contentSelected(_faq.id, _item)"
                        >
                          <strong>{{ _item.name }}</strong>
                          <p class="pt-1"><strong><small>{{ _item.description }}</small></strong></p>
                          
                        </vs-button>
                      </vx-input-group>
                    </vx-card>
                  </li>
                </ul>
              </div>
            </div>
          </vs-collapse-item>
        </vs-collapse>
      </li>
    </ul>
    <ul v-show="faqs.length == 0">
      <li>
        <p style="color:white;font-weight:500;font-size:16px;padding-top:5px">There are no Q&A's available right now...</p>
      </li>
    </ul>
    <!-- use selectedItem for this popup -->
    <vs-popup title="Play Podcast" id="resource-popup" :active.sync="podcastPopupActive">
      <div class="vx-row" v-if="Object.keys(selectedItem).length > 0">
        <div class="vx-col w-full">
          <div :id="`podcast-container_${selectedItem.faqId}_${selectedItem.id}`" :ref="`podcastViewer_${selectedItem.faqId}_${selectedItem.id}`" class="w-full vs-con-loading__container">
            <video :id="`podcastPlayer_${selectedItem.faqId}_${selectedItem.id}`" class="media-video-player card-video" controls />
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
  import vSelect from 'vue-select';
  import Plyr from 'plyr';
  import 'plyr/dist/plyr.css';  
  export default {
    data() {
      return {
        query: "",
        faqs: [],
        showHelpfulBtns: true,
        currentOpenItem: {},
        showPlayer: false,
        podcastPlayer: null,
        fileExt: "",
        source: [],
        selectedItem: {},
        podcastPopupActive: false,
        windowWidth: window.innerWidth
      }
    },
    components: {
      vSelect,
      Plyr
    },
    computed: {
      
    },
    watch: {
      podcastPopupActive: function(val) {
        if (!val) {
          this.destroyPlayer();
        }
      }
    },
    methods: {
      executeSearch() {
        var self = this;
        self.loadData();
      },
      loadData() {
        var self = this;
        self.showLoadingOnElement("whole_page", 1, "material");

        var onSuccess = response => {
          self.faqs = response.data;
        };
        var onFinally = response => {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        };

        self.$ajaxGet(self, `Faq/ListFaqsStudent?moduleId=${self.$route.query.module}&query=${self.query}`, onSuccess, onFinally);
      },
      faqFeedback(faqId, helpful) {
        var self = this;
        self.showHelpfulBtns = false;
        self.currentOpenItem = document.getElementsByClassName("open-item")[0];
        self.$ajaxGet(self, `Faq/FaqFeedback?faqId=${faqId}&helpful=${helpful}`);
      },
      getIcon(item) {
        switch (item.typeInt) {
          case 1:
            return "YoutubeIcon";
          case 2:
            return "FileTextIcon"
          case 3:
            return "MicIcon"
        };
      },
      contentSelected(faqId, item) {
        var self = this;
        // if (self.selectedItem.id != item.id) {
          self.currentOpenItem = document.getElementsByClassName("open-item")[0];
          self.selectedItem = item;
          self.selectedItem.faqId = faqId;
          self.showPlayer = false;
          self.destroyPlayer();
          switch (item.typeInt) {
            case 1:
              self.$router.push({ name: 'MultimediaVideoViewer', query: { id: item.id, url: item.url, module: self.$route.query.module, n: self.$route.query.n, orig: "q&a" } });
              self.selectedItem = {};
              return;
            case 2:
              self.$router.push({ name: 'DocumentViewer', query: { id: item.id, url: item.url, module: self.$route.query.module, n: self.$route.query.n, mentoring: true, orig: "q&a" } });
              self.selectedItem = {};
              return;
            case 3:
              self.podcastPopupActive = true;
              self.showPlayer = true;
              setTimeout(function() {
                self.playPodcast(item.id, faqId, item.url);
              }, 200)
              // return;
          };
        // }
      },
      playPodcast(itemId, faqId, podcastUrl) {
        var self = this;
      



        var oldVideoElement = document.getElementsByClassName("media-video-player")[0];
        oldVideoElement.remove();

        var videoContainerDiv = document.getElementById(`podcast-container_${faqId}_${itemId}`);

        var videoElement = document.createElement('video');
        videoElement.id = `podcastPlayer_${faqId}_${itemId}`;
        videoElement.classList.add('media-video-player');
        videoElement.classList.add('card-video');
        videoElement.setAttribute('controls', true);

        videoContainerDiv.appendChild(videoElement);




        self.podcastPlayer = new Plyr(`#podcastPlayer_${faqId}_${itemId}`, {
          autoplay: false
        });
        // self.showLoadingOnElement(`podcastViewer_${faqId}_${itemId}`, 1, "material");

        var counter = 0;
        self.podcastPlayer.on('canplay', event => {
          counter++;
          if(counter == 2){
            self.$vs.loading.close(self.$refs[`podcastViewer_${faqId}_${itemId}`].$el);
          }
        });

        self.fileExt = podcastUrl.substr(podcastUrl.lastIndexOf(".") + 1);
        self.source = [{ type: "audio/" + self.fileExt, src: podcastUrl }];
        self.podcastPlayer.source = {
          type: 'audio',
          sources: self.source
        };

        // self.selectedItem = {};
      },
      destroyPlayer() {
        var self = this;
        if(self.podcastPlayer)
          self.podcastPlayer.destroy();
      },
      showLoadingOnElement(element, scale, type, color) {
        var self = this;
        self.$vs.loading({
          color: color,
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      handleWindowResize(event) {
        this.windowWidth = event.currentTarget.innerWidth;
      },
      initCollapseContent() {
        var self = this;

        var previousOpenItem = self.currentOpenItem;
        var openItem = document.getElementsByClassName("open-item");

        var openItemContent = null;
        if (openItem.length > 0) {
          for (var i = 0; i < openItem[0].childNodes.length; i++) {
              if (openItem[0].childNodes[i].className == "vs-collapse-item--content") {
                openItemContent = openItem[0].childNodes[i];
                break;
              }        
          }

          openItemContent.style.maxHeight = "max-content"

          if (self.currentOpenItem.id == openItem[0].id) {
            self.previousOpenItem = {};
          }

          self.currentOpenItem = openItem[0];

          var hasPrevious = Object.keys(previousOpenItem).length > 0;

          if (!hasPrevious) {
            self.showHelpfulBtns = true;
          } else if (hasPrevious && self.currentOpenItem.id != previousOpenItem.id) {
            self.showHelpfulBtns = true;
          }
        }
      }
    },   
    mounted() {
      var self = this;
      self.loadData();

      document.getElementById("collapse").addEventListener("click", function(){
        if (Object.keys(self.currentOpenItem).length > 0) {
          self.initCollapseContent();
        }
        else {
          self.currentOpenItem = document.getElementsByClassName("open-item")[0];

          self.initCollapseContent();
        }
      });

      self.$nextTick(() => {
        window.addEventListener("resize", self.handleWindowResize);
      });
    },
    beforeDestroy() {
      window.removeEventListener("resize", self.handleWindowResize);
    }
  }

</script>

<style lang="scss">
.helpful_btns__container {
  .helpful_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }
  //da1e26 - b11638 rooi || 1caf00 - 037500 groen
  #helpful-btn {
    border-radius: 25px 0 0 25px !important;
    background-image: linear-gradient(#1caf00,  #037500) !important;
  }

  #unhelpful-btn {
    border-radius: 0 25px 25px 0 !important;
    background-image: linear-gradient(#da1e26,  #b11638) !important;
  }

  #done-btn {
    border-radius: 25px !important;
    background-image: linear-gradient(#1caf00,  #037500) !important;
  }
}

div[id*='podcast-container_'] {
  overflow: visible !important;

  border-style: solid !important;
  border-width: 2px !important;
  border-radius: 30px !important;

  .plyr--audio .plyr__controls {
    background: rgba(250, 250, 250, 0) !important;
    color: white !important;

    .plyr__control:hover {
      background: rgba(var(--vs-fontcolor), 1) !important;
    }
  }
  
  .plyr--full-ui input[type=range] {
    color: rgba(255, 255, 255, 1) !important;
  }
}
</style>
